module.exports = {
    APPLICATION_ID: 'HXAKZORTor8fuZ2cCLVzcvFQhC497n1fDsckyefp',
    JAVASCRIPT_KEY: 'RqMvkb26PTjMjp778OpLST7iZHrIjIthIPnu9ome',
    SERVER_URL: 'https://parseapi.back4app.com/'
}